/*
 * @Author: your name
 * @Date: 2021-06-22 15:43:35
 * @LastEditTime: 2021-08-03 17:56:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \standard-business\client\src\utils\constant\modules\seller.js
 */
export default {
  DEF_COOKIE_TIME: 0.5,
  DEF_EXPORT_DATE_FORMAT: 'YYYY-MM-DD-HH-mm-ss',
  DEF_EXPORT_DATE_FORMAT_2: 'YYYY-MM-DD:HH-mm-ss',
  // @ApiModelProperty(value = "商户类型 1-好店代运营 2-商户自营")
  SELLER_TYPE: {
    agent: 1,
    selfSupport: 2,
  },
  // 具体逻辑查看币种展示组件
  CURRENCY_MAP: {
    // 优化 如要新增币种必须配置, 或者设计一种规范, 因为币种的计算逻辑不一样
    JPY: {
      symbol: 'JPY',
      displaySymbol: 'JPY',
      displayName: '日元',
      spaceBetSymbol: true, // 是否展示空格 JPY 123.00
      needTransfer: true, // 是否有转换逻辑 如展示 JPY123(约XX元)
      displayPrecision: 2, // 展示精度,如果需要 (如优惠券就无精度)
      calcPrecision: 0, // 计算精度, 需要计算保留的位数
    },
    CNY: {
      symbol: 'CNY',
      displaySymbol: '¥',
      displayName: '人民币',
      spaceBetSymbol: true, // 是否展示空格
      needTransfer: false, // 是否有转换逻辑 如展示 JPY123(约XX元)
      displayPrecision: 2, // 展示精度,如果需要 (如优惠券就无精度)
      calcPrecision: 2, // 计算精度, 需要计算保留的位数
    },
  },
};
